export default "__VITE_ASSET__DZQGCp5D__"